import type { Product } from '@/types'
import { Link } from '@tanstack/react-router'

interface ProductCardProps {
  product: Product
}

export function ProductCard({ product }: ProductCardProps) {
  const currencySymbol = '₹'
  const hasDiscount = product.compare_at_price && product.compare_at_price > product.price
  const discountPercent = hasDiscount 
    ? Math.round((1 - product.price / product.compare_at_price!) * 100)
    : 0

  return (
    <Link
      to={"/products/$slug" as any}
      params={{ slug: product.slug } as any}
      className="group block"
    >
      <div className="bg-white rounded-lg overflow-hidden border hover:shadow-lg transition-shadow">
        {/* Image */}
        <div className="aspect-square bg-gray-100 relative overflow-hidden">
          {product.images && product.images[0] ? (
            <img
              src={product.images[0].url}
              alt={product.images[0].alt_text || product.name}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-gray-400">
              No image
            </div>
          )}
          
          {/* Badges */}
          <div className="absolute top-2 left-2 flex flex-col gap-1">
            {hasDiscount && (
              <span className="bg-red-600 text-white text-xs px-2 py-1 rounded">
                -{discountPercent}%
              </span>
            )}
            {!product.in_stock && (
              <span className="bg-gray-900 text-white text-xs px-2 py-1 rounded">
                Sold Out
              </span>
            )}
          </div>
        </div>

        {/* Content */}
        <div className="p-4">
          <h3 className="font-medium text-gray-900 mb-1 truncate group-hover:text-blue-600">
            {product.name}
          </h3>
          
          {product.category && (
            <p className="text-xs text-gray-500 mb-2">{product.category.name}</p>
          )}

          <div className="flex items-baseline gap-2">
            <span className="font-bold text-lg">
              {currencySymbol}{product.price.toLocaleString()}
            </span>
            {hasDiscount && (
              <span className="text-gray-500 text-sm line-through">
                {currencySymbol}{product.compare_at_price!.toLocaleString()}
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  )
}
